module.exports = __webpack_public_path__ + "img/pro_four_5.c5845271.jpg";